import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/index';
import { STORE_FEATURE_KEY_APPOINTMENT_SETTINGS } from './appointment-settings.reducers';

const loadingSelector = (appState: any) => appState[STORE_FEATURE_KEY_APPOINTMENT_SETTINGS].loading;
const displayTwowaySelector = (appState: any) => appState[STORE_FEATURE_KEY_APPOINTMENT_SETTINGS].displayTwoway;
const displayBirthdaySelector = (appState: any) => appState[STORE_FEATURE_KEY_APPOINTMENT_SETTINGS].displayBirthday;
const displayIncorrectDestinatorSelector = (appState: any) => appState[STORE_FEATURE_KEY_APPOINTMENT_SETTINGS].displayIncorrectDestinator;
const showProvidersSelector = (appState: any) => appState[STORE_FEATURE_KEY_APPOINTMENT_SETTINGS].showProviders;

@Injectable()
export class AppointmentSettingsSelectors {
    constructor(private store: Store<any>) {
    }

    selectLoading(): Observable<boolean> {
        return this.store
            .pipe(select(loadingSelector));
    }

    selectDisplayTwoway(): Observable<boolean> {
        return this.store
            .pipe(select(displayTwowaySelector));
    }

    selectDisplayBirthday(): Observable<boolean> {
        return this.store
            .pipe(select(displayBirthdaySelector));
    }

    selectDisplayIncorrectDestinator(): Observable<boolean> {
        return this.store
            .pipe(select(displayIncorrectDestinatorSelector));
    }

    selectShowProviders(): Observable<boolean> {
        return this.store
            .pipe(select(showProvidersSelector));
    }
}
